<template>
	<div>
		<v-dialog v-model="openD" max-width="500" persistent>
			<v-card>
				<v-card-title class="headline text-xs-center">Descarga programaciones por {{type === 'date' ? 'fecha' : '' }}</v-card-title>
				<v-card-text>
					<v-menu
							key="menu"
							v-if="type === 'date'"
							ref="fechaProgramaciones"
							v-model="fechaProgramaciones.menu"
							:close-on-content-click="false"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							offset-y
							full-width
							min-width="290px"
					>
						<v-text-field
								slot="activator"
								label="Fecha programaciones"
								v-model="result.dateProgramaciones"
								name="Fecha programaciones"
								prepend-icon="event"
								v-validate="'required|date_format:yyyy-MM-dd|date_between:' + fechaProgramaciones.minDate + ',' + fechaProgramaciones.maxDate + ',true'"
								:error-messages="errors.collect('Fecha programaciones')"
								readonly
						></v-text-field>
						<v-date-picker
								ref="picker"
								v-model="result.dateProgramaciones"
								locale="es-co"
								:min="fechaProgramaciones.minDate"
								:max="fechaProgramaciones.maxDate"
								@input="$refs.fechaProgramaciones.save(result.dateProgramaciones)"
								@change="() => {
							  let index = $validator.errors.items.findIndex(x => x.field === 'Fecha programaciones')
							  $validator.errors.items.splice((index !== -1) ? index : 0, (index !== -1) ? 1 : 0)
							}"
						></v-date-picker>
					</v-menu>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
							@click="close"
					>
						{{load ? 'Cerrar' : 'Cancelar'}}
					</v-btn>
					<v-btn
							color="primary"
							:loading="load"
							:disabled="load"
							@click="submit"
					>
						Descargar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
  	props: {
  	    type: {
  	        type: String,
			default: 'date'
		}
	},
    data: () => ({
        identificationTypes: null,
        fechaProgramaciones: {
            menu: false,
            minDate: '1900-01-01',
            maxDate: new Date().toISOString().substr(0, 10)
		},
        openD: false,
        load: false,
		result: {
            dateProgramaciones: null
		}
	}),
	computed: {
	},
	watch: {
	},
	methods: {
  	    submit () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.$store.commit('snackbar', {color: 'warning', message: `Se está procesando la descarga de programaciones.`})
                    this.$emit('onProcessing', true)
                    this.load = true
                    const stringDate = this.type === 'date' ? `ProgramacionXFecha?FecProgramacion=${this.result.dateProgramaciones}` : ''
                    this.axios.get(`${stringDate}`)
                        .then(response => {
                            console.log('response en programaciones', response)
                            this.$emit('onProcessing', false)
                            this.$emit('onSuccess')
                            this.close()
                            this.$store.commit('reloadTable', 'tableProgramaciones')
                            this.$store.commit('snackbar', {color: 'success', message: `Se han descargado ${response.data.data.length} programaci${response.data.data.length === 1 ? 'ón' : 'ones'}`})
                            this.load = false
                        }).catch(e => {
                        this.$emit('onProcessing', false)
                        this.$emit('onSuccess', false)
                        this.load = false
                        this.$store.commit('snackbar', {color: 'error', message: `al descargar las programaciones`, error: e})
                    })
				}
            })
		},
		open () {
		  this.openD = true
		},
		loading (val = true) {
		  this.load = val
		},
		close () {
		  	this.openD = false
			setTimeout(() => {
                this.load = false
                this.result.dateProgramaciones = null
                this.$validator.reset()
			}, 300)
		}
  	}
}
</script>

